// docs: https://github.com/altostra/type-validations#readme
import { maybe, objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean, number, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPageTemplatesDuplicateResult = objectOf({
  info: string,
  template: maybe(
    objectOf({
      id: string,
      name: string,
      description: string,
      marked_as_deleted: boolean,
      last_edited_at: number,
      created_by: string,
      last_edited_by: string,
      last_edited_info: maybe(
        objectOf({
          d_id: string,
          name: string,
          time: number,
        }),
        true
      ),
      created_by_info: maybe(
        objectOf({
          d_id: string,
          name: string,
          time: number,
        }),
        true
      ),
      grapes_js_data: maybe(any, true),
      derived_landing_page_id: string,
      tag_names: arrayOf(string),
      territory_ids: arrayOf(string),
      html: maybe(any, true),
    }),
    true
  ),
});
